module.exports = {
  platform: 'voice',
  name: 'Schedule',
  node: 'schedule',
  bg: '#FFFFFF',
  note: '',
  property: {
    schedule: '',
    schedule_name: ''
  }
}
